import axios from 'axios';

export const checkSession = (sessionId, skipStatusCheck) => axios.get(`/api/Application/checksession/${sessionId}?skipStatusCheck=${skipStatusCheck}`);
export const fetchApplicationDetails = sessionId => axios.get(`/api/Application/getapplication/${sessionId}`);
export const fetchConsents = (clientId, productId, sessionId) => axios.get(`/api/Application/Consents/${clientId}/${productId}/${sessionId}`);

// FIX API NAME
export const generateOTP = (sessionId, mobileNo) =>
    axios({
        method: 'post',
        url: '/api/Application/genarateotp',
        data: {
            sessionId,
            mobileNo,
        },
        headers: { 'Content-Type': 'application/json' },
    });

export const submitApplication = submitApplicationFormViewModel =>
    axios({
        method: 'post',
        url: '/api/Application/submitapplication',
        data: JSON.stringify(submitApplicationFormViewModel),
        headers: { 'Content-Type': 'application/json' },
    });

export const uploadFile = (file, source) => {
    const formData = new FormData();
    formData.append('File', file, file.name);
    formData.append('source', source);

    return axios({
        method: 'post',
        url: '/api/Application/uploadfile',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const validateOTP = (sessionId, otp) =>
    axios({
        method: 'post',
        url: '/api/Application/validateotp',
        data: {
            sessionId,
            otp,
        },
        headers: { 'Content-Type': 'application/json' },
    });
